import { EntityActionReducerBuilderInterface, REQUEST_STATE } from "../../dataTypes";
import { fetchCurrentUser } from "../../session/reducers/fetchCurrentUser";
import { User } from "../dataTypes";
import { userAdapter } from "../userAdapter";

export const addFetchCurrentUserReducers = (builder: EntityActionReducerBuilderInterface<User>) => {
  builder.addCase(fetchCurrentUser.fulfilled, (state, action) => {
    const { payload } = action;

    userAdapter.upsertOne(state, { ...payload, fetchedTimestamp: Date.now(), requestState: REQUEST_STATE.FULFILLED });
  });
};
